import * as JSZip from 'jszip';
const etree = require('elementtree');

export class MetaData {

  public async getMetaData(value: string) {
    // console.log(value);
    let returnObject = {};
    // Handle here for fail case
    if (value === "null") {
      returnObject = {
        "error": "Template is empty."
      }
      return JSON.stringify(returnObject, null, 4);
    }
    // Handle here for pass case.
    const zip = new JSZip();
    const jsonValue = JSON.parse(value);
    const bufferValue = Buffer.from(jsonValue.file, 'base64');
    const ourRequiredValues = ["dcterms:created", "dc:creator", "dc:language", "cp:lastModifiedBy", "dcterms:modified", "cp:revision", "gsadjgha"]
    // console.log(bufferValue);
    const savedAttributeMap = new Map();
    await zip.loadAsync(bufferValue).then(async (contents) => {
      // @ts-ignore: Object is possibly 'null'.
      await contents.file("docProps/core.xml").async("string").then((content) => {
        const coreObjects = etree.parse(content);
        coreObjects.getroot().getchildren().forEach((child: {
          tag: any;text: any;
        }) => {
          savedAttributeMap.set(child.tag, child.text)
        });
      });
      // @ts-ignore: Object is possibly 'null'.
      await contents.file("docProps/app.xml").async("string").then((content) => {
        const appObjects = etree.parse(content);
        appObjects.getroot().getchildren().forEach((child: {
          tag: any;text: any;
        }) => {
          savedAttributeMap.set(child.tag, child.text)
        });
        // console.log(savedAttributeMap);
      });
      
    });
    // console.log(savedAttributeMap);
    for (const i of ourRequiredValues) {
      if (savedAttributeMap.has(i)) {
        returnObject[i] = savedAttributeMap.get(i);
      } else {
        returnObject[i] = undefined;
      }
    }
    // console.log(returnObject);
    return JSON.stringify(returnObject, null, 4);
  }
}

export const MainMetaData = new MetaData();
export default MainMetaData;


// WEBPACK FOOTER //
// ./src/logic/metadata.ts